<div class="contenedor">
  <h6>AMDG</h6>
  <div class="consolaContainer">

    EDITOR XPATH
    <mat-button-toggle-group name="fontStyle">
      <mat-button-toggle (click)="EjecutarDesc(consolas.value)" value="Interpretar">AST Desc </mat-button-toggle>
      <mat-button-toggle (click)="ArbolAscAST(consolas.value)" value="Interpretar2">AST Asc </mat-button-toggle>
      <mat-button-toggle (click)="EjecutarAsc(consolas.value)" value="Interpretar2">Consulta </mat-button-toggle>
    </mat-button-toggle-group>
    <textarea #consolas id="consolas" class="consola"></textarea>
  </div>
  <div class="editores">
    <div id="ediT">
      <label>Editor XML</label>
      <br>
      <mat-button-toggle-group name="fontStyle" aria-label="Font Style">
        <mat-button-toggle (click)="interpretarContenido(contenido.value)" value="Interpretar">Interpretar XML Asc
        </mat-button-toggle>
        <mat-button-toggle (click)="interpretarContenidoDesc(contenido.value)" value="InterpretarDesc">Interpretar XML
          Desc</mat-button-toggle>
        <mat-button-toggle value="Abrir Archivo" (click)="textInput.click()">Abrir Archivo XML</mat-button-toggle>
        <input type="file" hidden="true" #textInput onclick="this.value=null" (change)="textInputChange($event)"
          accept=".ty" />
        <mat-button-toggle value="Guardar">Guardar XML</mat-button-toggle>
      </mat-button-toggle-group>
      <textarea #contenido id="contenido" class="forma" (this.onload)="getConsola()"></textarea>
      <label>SALIDA CONSULTAS</label>
      <textarea id="resultado" class="textareanumber3"></textarea>
      <label>SALIDA CD3</label>
      <br>
      <mat-button-toggle id="mostrar" (click)="finalizarCD3()" value="Interpretar">MOSTRAR CD3
      </mat-button-toggle>
      <mat-button-toggle id="mostrar" (click)="Optimizar(cdirecciones.value)" value="Optimizar">OPTIMIZAR
      </mat-button-toggle>
      <textarea #cdirecciones id="cdirecciones" class="textareanumber4"></textarea>

    </div>
    <div><br></div>
    <div id="ediT">
      <label>EDITOR XQUERY</label>
      <br>
      <mat-button-toggle-group name="fontStyle" aria-label="Font Style">
        <mat-button-toggle (click)="InterpretarXQUERY(resultado.value)" value="Interpretar">Consulta XQUERY
        </mat-button-toggle>
      </mat-button-toggle-group>
      <textarea #resultado id="XQUERY" class="textareanumber"></textarea>

    </div>

  </div>